import { a as __makeTemplateObject, b as __spreadArray } from './tslib.es6-86dc5b0c.js';
import { css } from 'styled-components';

var largeQuery = '(min-width: 768px)';
var mediumQuery = '(min-width: 375px)';
var large = function (parts) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media ", " {\n    ", "\n  }\n"], ["\n  @media ", " {\n    ", "\n  }\n"])), largeQuery, css.apply(void 0, __spreadArray([parts], args, false)));
};
var medium = function (parts) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  @media ", " {\n    ", "\n  }\n"], ["\n  @media ", " {\n    ", "\n  }\n"])), mediumQuery, css.apply(void 0, __spreadArray([parts], args, false)));
};
var templateObject_1, templateObject_2;

export { largeQuery as a, large as l, medium as m };
